import "./App.scss";
import React from "react";
import { Provider } from "react-redux";
import store from "./store";
import { AppProvider } from "./contexts/AppContext";
import AuthGuard from "guards/AuthGuard";
import { Helmet } from "react-helmet";
import { __ } from "services/Translator";

function App(props) {
  return (
    <Provider store={store}>
      <AppProvider>
        <Helmet>
          <title>{__("Joker Casino | Sign Up today for a 100% of up to 1BTC!")}</title>
          <meta
            name="description"
            content={__(
              "Joker Casino! Sign Up today and receive bonuses on your first 2 Deposits totalling 2.5 BTC - Double your Coins on us!"
            )}
          />
        </Helmet>
        <AuthGuard {...props} />
      </AppProvider>
    </Provider>
  );
}

export default App;
